import { validateField, clearFields, setFieldOptions, submitFields } from './helpers/form'
import {
	SET_CLIENTREQUEST_EDIT_LOAD_FIELDS,
	CLEAR_CLIENTREQUEST_EDIT_FIELDS,
	VALIDATE_CLIENTREQUEST_EDIT_FIELD,
	SUBMIT_CLIENTREQUEST_EDIT_FIELDS
} from '../../../actions/pages/clientaccount-page'

export function clientRequestActivate(
	state = {
		valid: false,
		fields: [
			{
				name: 'AllowedCountries',
				value: '',
				errors: [],
				rules: {
					title: 'Countries',
					required: true
				},
				placeholder: 'Select countries',
				options: []
			},
			{
				name: 'AuthDurationDays',
				value: '',
				errors: [],
				rules: {
					title: 'Access duration in days',
					required: true,
					numericGreaterThanZero: true
				},
				placeholder: 'Access duration in days',
				options: []
			}
		]
	},
	action
) {
	switch (action.type) {
		case SET_CLIENTREQUEST_EDIT_LOAD_FIELDS:{
			let fields = state.fields.map(field => {
				if (field.name === "AuthDurationDays" && action.data.AccessDuration !== undefined) {
					let newValue = action.data.AccessDuration == 0 ? "" : action.data.AccessDuration;
					return {
						...field,
						value: newValue,
						errors: []
						}
				} else {
					return field;
				}
			  })
			  
			  var newState = Object.assign({}, state, {
				fields: Array.from(fields)
			  });

			  return setFieldOptions(newState, 'AllowedCountries', action.data.AllCountries);
		}
		case VALIDATE_CLIENTREQUEST_EDIT_FIELD:
			return validateField(state, action);
		case CLEAR_CLIENTREQUEST_EDIT_FIELDS:
			return clearFields(state);
		case SUBMIT_CLIENTREQUEST_EDIT_FIELDS:
			return submitFields(state, action);
		default:
			return state
	}
}